import { render, staticRenderFns } from "./RequisitionList.vue?vue&type=template&id=eb9ea5ae&scoped=true"
import script from "./RequisitionList.vue?vue&type=script&lang=js"
export * from "./RequisitionList.vue?vue&type=script&lang=js"
import style0 from "./RequisitionList.vue?vue&type=style&index=0&id=eb9ea5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9ea5ae",
  null
  
)

export default component.exports